import { ReactNode } from 'react';

import clsx from 'clsx';

import DeviceAdvertWrapper from '@adverts/components/DeviceAdvertWrapper';
import Leader from '@adverts/components/Leader';
import { Device } from '@device/Device';

export interface LayoutInnerPageWrapperProps {
  children?: ReactNode;
  className?: string;
  isBarActive?: boolean;
}

const LayoutInnerPageWrapper = ({
  children,
  className,
}: LayoutInnerPageWrapperProps) => (
  <div id="brand-a" className="brand-a">
    <div id="brand-b" className="brand-b">
      <div id="brand-c" className="brand-c">
        <DeviceAdvertWrapper device={Device.DESKTOP}>
          <Leader />
        </DeviceAdvertWrapper>
        <div
          className={clsx(
            'mx-auto flex max-w-[1080px] flex-wrap items-start bg-white md:relative lg:rounded-t-[80px]',
            className,
          )}
        >
          {children}
        </div>
      </div>
    </div>
  </div>
);

export default LayoutInnerPageWrapper;
